module.exports = __webpack_public_path__ + "img/dsh1.44a2c6b8.jpg";